import { Option } from "../../../../components/reusable-components/form/FormAutocomplete";
import { EntityType } from "./EntityType";

export const ENTITY_TYPE_OPTIONS: Option<EntityType>[] = Object.entries(EntityType).map(([label, value]) => ({
    label: value,
    value,
  }));
  